module.exports = __webpack_public_path__ + "img/seguro.3e986a6a.jpeg";